// Compare the sorted arrays
// Function to compare two arrays of objects and return changed objects
export const findChangedObjects = (arr1 = [], arr2 = [], idKey = 'id') => {
  const changedObjects = [];
  const arr2Map = new Map(arr2.map((obj) => [obj[idKey], obj]));

  arr1.forEach((obj1) => {
    const obj2 = arr2Map.get(obj1[idKey]);
    if (!obj2 || !deepEqual(obj1, obj2)) {
      changedObjects.push(obj1);
    }
  });

  // Check for objects in arr2 that are not in arr1
  arr2.forEach((obj2) => {
    if (!arr1.some((obj1) => obj1[idKey] === obj2[idKey])) {
      changedObjects.push(obj2);
    }
  });

  return changedObjects;
};

// Function to compare two objects
export const deepEqual = (obj1 = {}, obj2 = {}) => {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const key of keys1) {
    const val1 = obj1[key];
    const val2 = obj2[key];
    const areObjects = typeof val1 === 'object' && typeof val2 === 'object';
    if ((areObjects && !deepEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
      return false;
    }
  }

  return true;
};
